export enum ReactionType {
	Like = 'like',
	Love = 'love',
	Celebrate = 'celebrate',
	Amaze = 'amaze',
	Laugh = 'laugh',
}
export interface ReactionUser {
	id: string;
	display_name: string;
	email: string;
	first_name: string;
	full_pic_url: string;
	last_name: string;
	profile_pic_url: string;
	username: string;
}
export interface ReactionData {
	id: string;
	emoji: string;
	user_id: string;
	user: ReactionUser;
}
